module.exports = __webpack_public_path__ + "static/media/vrinda_ahuja.356ee670.jpeg";